import { HeaderComponent } from './headerComponent';
import { HeaderComponentData } from '../types';

interface ColumnHeaderComponentArgs {
  componentId: string;
  showExpander: boolean;
  isExpanded: boolean;
  isHighlighted: boolean;
  expanderClicked: () => void;
  address: (string | null)[];
  headerComponentData: HeaderComponentData;
}

const ColumnHeaderComponent = ({
  componentId,
  showExpander,
  expanderClicked,
  isExpanded,
  isHighlighted,
  address,
  headerComponentData,
}: ColumnHeaderComponentArgs) => (
  <HeaderComponent
    componentId={componentId}
    address={address}
    headerComponentData={headerComponentData}
    showExpander={showExpander}
    expanderClicked={expanderClicked}
    isExpanded={isExpanded}
    isRowHeader={false}
    containerStyle={address.length === 1 ? { borderRight: '1px solid' } : {}}
    iconContainerStyle={{
      marginLeft: 'auto',
      marginTop: '-2px',
      height: '20px',
    }}
    isHighlighted={isHighlighted}
  />
);
export { ColumnHeaderComponent };
